import { render } from "./AddressListOfNei.vue?vue&type=template&id=c421c50c&scoped=true"
import script from "./AddressListOfNei.vue?vue&type=script&lang=ts"
export * from "./AddressListOfNei.vue?vue&type=script&lang=ts"

import "./AddressListOfNei.vue?vue&type=style&index=0&id=c421c50c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c421c50c"

export default script